<template>
    <v-layout class="app-content login-page">
        <v-flex>
            <v-layout class="form-layout" wrap pa-12 align-center>
                <v-card class="pa-4 " style="width: 400px; border-radius: 10px;">
                    <m-form ref="form" @submit.prevent="loginPagamento">
                        <m-text-field
                                placeholder="CPF/CNPJ"
                                v-model="model.cpf"
                                v-mask="cpfCnpjMask"
                                filled
                                solo
                                prepend-inner-icon="chrome_reader_mode"
                                validate-on-blur
                                class="required pagamento-text-field"
                                :rules="[$rules.required, model.cpf.length <= 14 ? $rules.cpf : $rules.cnpj]"
                        />
                        <m-text-field placeholder="Código de Pagamento"
                                      v-model="model.codigo"
                                      v-input-filter="[$filters.alphanumeric]"
                                      type="text"
                                      filled
                                      solo
                                      prepend-inner-icon="rod-coin-hand"
                                      validate-on-blur
                                      class="required pagamento-text-field"
                                      :rules="[$rules.required]"
                                      maxlength="100">
                        </m-text-field>
                        <v-flex>
                            <v-btn x-large class="button btn-default" type="submit">Entrar</v-btn>
                        </v-flex>
                    </m-form>
                </v-card>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
  import { notification } from '@/plugins/helpers'
  import { AlertTypes } from '../../plugins/alerts_types'

  export default {
    data () {
      return {
        document: '',
        permite_cnpj_alfanumerico: false,
        model: {
          cpf: '',
          cnpj: '',
          codigo: ''
        },
        regras: null
      }
    },
    computed: {
      cpfCnpjMask () {
        return {
          mask: ['SSS.SSS.SSS-SS', 'SS.SSS.SSS/SSSS-SS'],
          tokens: {
            'S': {
              pattern: /[A-Za-z0-9]/,
              transform: (char) => char.toUpperCase()
            }
          }
        }
      }
    },
    methods: {
      loginPagamento () {
        const form = this.$refs.form
        if (form.validate()) {
          this.$http.post('/pagamento/cliente/login', this.model)
            .then((res) => {
              if (res.data.status) {
                const vendedor = false
                const { id_pedido, token, flavor, bandeiras_base } = res.data
                this.$router.push({ name: 'cliente-pagamento', params: { id_pedido, token, flavor, bandeiras_base, vendedor } })
              } else {
                notification(AlertTypes.WARN, res.data.message)
              }
            }).catch(err => {
              notification(AlertTypes.ERROR, err, 'Ocorreu um erro ao buscar os dados do pedido')
            })
        }
      }
    }
  }
</script>

<style scoped lang="scss">
    .app-content {
        background-image: url(../../assets/img/login-bg.jpg) !important;
    }
</style>

<style>
    .pagamento-text-field .v-input__icon > .v-icon {
        color: #b5bcbd !important;
    }

    .pagamento-text-field.m-text-field--filled.m-text-field--single-line input {
        margin: 0 0 0 10px;
    }
</style>
